import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AsyncAdminService } from 'src/app/services/async-admin.service';
import { AuthService } from 'src/app/services/auth/auth.service';

/**
 * Perfil bancario: con qué contrato nacen los pagos de los botones y del Débito Inmediato.
 * Desde el 4-nov-2026 es solo de consulta (perfil activo e historial): el cambio MT → CT ya se hizo (31-oct) y no hay vuelta
 * atrás, así que la pantalla ya no ofrece pasar a otro perfil. Pantalla aparte, a la que se llega desde Pagos Asíncronos
 * (contrato activo) y desde Parámetros del Sistema y Gestión de Métodos de Pago (?pestana=cuentas abre «Cuentas por contrato»).
 */
@Component({
  selector: 'app-perfil-bancario',
  templateUrl: './perfil-bancario.component.html',
  styleUrls: ['./perfil-bancario.component.css']
})
export class PerfilBancarioComponent implements OnInit {

  perfilBancario: any = null;          // { activo, desde, historia[] }
  perfilLoading = false;
  perfilError: string | null = null;

  pestana: 'switch' | 'cuentas' = 'switch';

  constructor(private asyncAdminService: AsyncAdminService, public _auth: AuthService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.get('pestana') === 'cuentas') this.pestana = 'cuentas';
    this.loadPerfilBancario();
  }

  /** Estado del perfil activo. No tumba el resto de la pantalla si falla. */
  async loadPerfilBancario(): Promise<void> {
    if (!this._auth.hasPermission('config.perfil_bancario.read')) return;
    this.perfilLoading = true;
    this.perfilError = null;
    try {
      const estado = await this.asyncAdminService.getPerfilBancario();
      this.perfilBancario = estado?.data || null;
    } catch (error: any) {
      console.error('❌ [PERFIL-BANCARIO] Error cargando perfil bancario:', error);
      this.perfilError = error?.error?.message || error?.error?.msg || 'No se pudo consultar el perfil bancario';
    } finally {
      this.perfilLoading = false;
    }
  }
}
